import { isWeb, usePresence } from "tamagui";
import { type ViewProps, YStack } from "../Stacks";

/**
 * Layout spacer for `AnimatePresence`: grows from 0 on mount, collapses on
 * exit. The web CSS driver reads an exiting element's start height from
 * `enterStyle`, so `exitStyle={{ height: 0 }}` snaps; web drives the collapse
 * as a plain prop instead.
 */
export const ExpandSpacer = ({
  height
}: Pick<ViewProps, "height">) => {
  const [isPresent] = usePresence();
  return <YStack height={isWeb && !isPresent ? 0 : height} enterStyle={{
    height: 0
  }} transition="expand" {...isWeb ? {} : {
    exitStyle: {
      height: 0
    }
  }} data-sentry-element="YStack" data-sentry-component="ExpandSpacer" data-sentry-source-file="ExpandSpacer.tsx" />;
};